<template>
  <div class="contact" id="contact">
    <v-container class="py-12">
      <v-row class="pt-10">
        <v-col 
          md="8"
          offset-md="2"
          class="px-12">
          <h2 class="text-center">Contáctanos</h2>
          <hr class="hr-w my-8 bg-red">
          <p class="text-center my-8">¿Interesado en <span class="text-red bold">Kefuri</span>? Ponte en contacto y te responderemos en breve. <br>
          Puedes escribirnos a <span class="text-red"> contacto@kefuri.cl </span> o bien hacerlo a través del siguiente formulario!</p>
          
          <v-form ref="form" v-model="valid" :lazy-validation="lazy">
            <v-text-field
              v-model="from_name"
                :rules="from_nameRules"
                label="Nombre"
                required
            ></v-text-field>

            <v-text-field
              v-model="from_email"
                :rules="from_emailRules"
                label="E-mail"
                hint="Escriba su dirección de correo electrónico que pronto lo contactaremos"
                required
            ></v-text-field>
            <v-textarea
              v-model="message"
                :rules="messageRules"
                label="Comentario"
                value=""
                hint="Escribanos un mensaje"
                required
                solo>
                Mensaje
            </v-textarea>
            <v-alert
                :value="alert"
                v-model="alert"
                type="success"
                dismissible
                transition="scale-transition"
              >
                El correo se ha enviado con éxito
              </v-alert>
              <v-checkbox
                v-model="checkbox"
                :rules="[v => !!v || 'Usted debe confirmar para continuar!']"
                label="Confirme por favor."
                required
              ></v-checkbox>
            <div class="d-flex justify-center">
              <v-btn
              :disabled="!valid"
                :loading="loading"
                @click="submit"
                @click.native="loader = 'loading'"
                class="mr-4 bg-red"
              >Enviar
              </v-btn>
            </div>
            
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
let emailjs = require("emailjs-com");
export default {

  data: () => ({
    valid: true,
    to_name:"",
    from_name: "",
    from_nameRules: [
      v => !!v || "Completar el nombre es obligatorio",
      v => (v && v.length > 3) || "El nombre debe ser mayor a tres caracteres"
    ],
    from_email: "",
    from_emailRules: [
      v => !!v || "Complete el E-mail por favor",
      v => /.+@.+/.test(v) || "E-mail es un campo obligatorio"
    ],
  
    message: "",
    messageRules: [v => !!v || "Ingrese un mensaje por favor"],
    alert: false,
    loader: null,
    loading: false,
    
    checkbox: false,
  }),
  
  watch: {
    loader () {
      const l = this.loader
      this[l] = !this[l]
      this.alert = true
      setTimeout(() => (this[l] = false), 3000)
      this.loader = null
      }
  },

  lazy: "false",
  
  created(){
    emailjs.init("user_76hm6yDIkUQ3WnRME0zjC");
  },

  methods: {
    submit() {
      let data = {
        from_name: this.from_name,
        from_email: this.from_email,
        message: this.message,
        to_name:"Equipo Kefuri"
      };

      if (this.$refs.form.validate()) {
        console.log("hola me estan por enviar");
        emailjs.send("Kefuri_email", "template_pggdb38", data, "user_76hm6yDIkUQ3WnRME0zjC").then(
          function(Response) {
            if (Response.text === "OK") {
              //alert("El correo se ha enviado con éxito");
            }
            console.log(
              "SUCCESS. status=%d, text=%s",
              Response.status,
              Response.text
            );
          },
          function(err) {
            alert("Ocurrio un problema al enviar  el correo");
            console.log("FAILDED. error=", err);
          },
          this.$refs.form.reset()
        );
      }
    },
    clear() {
      this.$refs.form.reset();
    }
  }
};
</script>

<style scoped lang="sass">

  .v-application .primary--text
    color: $primary-color !important

  .v-textarea textarea
    resize: none !important

</style>